<template>
  <div class="text-container">
    <div
      v-for="item in recognitionText"
      :key="item.id"
      class="text-content"
    >
      <div class="time">{{ item.time }}</div>
      <div class="car">{{ item.speaker }}</div>
      <div class="content">{{ item.text }}</div>
    </div>
    <div class="new-text">
      <span>查看最新的消息</span>
      <i class="el-icon-arrow-down"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "Recognition",
  props: {
    recognitionText: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.text-container {
  background: #F0F5F7;
  border-radius: 10px;
  height: 808px;
  position: relative;
  overflow: auto;
}

.text-content {
  border: 2px solid #FBFBFB;
  padding: 20px 13px;
  display: flex;
  align-items: center;

  .time {
    width: 150px;
    font-size: 16px;
    color: #666666;
  }

  .car {
    width: 100px;
    font-size: 16px;
    color: #666666;
  }

  .content {
    margin-left: 23px;

    font-size: 16px;
    color: #333333;
  }
}

.new-text {
  width: 134px;
  height: 46px;
  background: #FBFBFB;
  box-shadow: 0 0 8px 0 rgba(127, 147, 166, 0.4);
  border-radius: 10px;

  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  color: #999999;
}
</style>
